"use client";

import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useWishlist } from "@/contexts/WishlistContext";

export default function WishlistButton({
  productId,
  preventSave = false,
}: {
  productId: number;
  preventSave?: boolean;
}) {
  const { savedIds, toggle, pendingId } = useWishlist();
  const saved = savedIds.has(productId);

  if (preventSave && !saved) return null;

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      onClick={() => void toggle(productId)}
      disabled={pendingId === productId || (preventSave && !saved)}
      aria-label={
        preventSave && !saved
          ? "Teaser products cannot be saved"
          : saved
            ? "Remove from wishlist"
            : "Save to wishlist"
      }
      aria-pressed={saved}
      className="rounded-none"
    >
      <Heart data-icon="inline-start" className={saved ? "fill-current" : undefined} />
    </Button>
  );
}
